import { call, put, takeEvery, takeLatest } from "redux-saga/effects"
import httpInjectorService from "services/http-Injector.Service"

// Login Redux States
import { LOGIN_USER, LOGOUT_USER, SOCIAL_LOGIN } from "./actionTypes"
import { apiError, loginSuccess, logoutUserSuccess } from "./actions"

//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper"
import { toast } from "react-toastify"

const fireBaseBackend = getFirebaseBackend()

function* loginUser({ payload: { user, history } }) {
  try {
    const response = yield call(httpInjectorService.login, user)
    yield put(loginSuccess(response))

    // Check if response status indicates success
    if (response && response.status) {
      localStorage.setItem("authUser", JSON.stringify(response))
      localStorage.setItem("sessionExpired", "false")
      history("/dashboard")

      // Show success toast with autoClose of 3 seconds
      toast.success("Login successful!", {
        autoClose: 3000, // 3 seconds
      })
    } else {
      const errorMessage = response?.error || "Login failed. Please try again."
      toast.error(errorMessage, {
        autoClose: 3000,
      })
    }
  } catch (error) {
    const errorMessage = error?.error || "Login failed. Please try again."
    toast.error(errorMessage, {
      autoClose: 3000,
    })

    yield put(apiError(error))
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    localStorage.removeItem("authUser")

    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = yield call(fireBaseBackend.logout)
      yield put(logoutUserSuccess(response))
    }
    history("/login")
  } catch (error) {
    yield put(apiError(error))
  }
}

function* socialLogin({ payload: { type, history } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const fireBaseBackend = getFirebaseBackend()
      const response = yield call(fireBaseBackend.socialLoginUser, type)
      if (response) {
        history("/dashboard")
      } else {
        history("/login")
      }
      localStorage.setItem("authUser", JSON.stringify(response))
      yield put(loginSuccess(response))
    }
    if (response) history("/dashboard")
  } catch (error) {
    console.log("error", error)
    yield put(apiError(error))
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser)
  yield takeLatest(SOCIAL_LOGIN, socialLogin)
  yield takeEvery(LOGOUT_USER, logoutUser)
}

export default authSaga
